  <div class="doctalk-card" [ngClass]="{'doctalk-card-border': callingfrom !== screen.GRAND_ROUND}">
  <div class="position-relative hover-showing" >
    <div class="position-absolute w-100 h-100 masking-card"
    *ngIf="docCardObj?.channel?.content_visibility?.display==0 || docCardObj?.channel?.content_visibility?.display==2 || docCardObj?.hl?.mcnt">
    <app-product-masking-card [content_visibility]="docCardObj?.channel?.content_visibility"  [communityVisible]="docCardObj?.hl?.mcnt"></app-product-masking-card>
  </div>
  <div  (click)="navigatetodetail(docCardObj?.doctalks_id,docCardObj?.product_type)">
    <div class="row"
      *ngIf="docTalkSection=='features_videos' ||  docTalkSection=='user_speciality'  || docTalkSection=='continue_watch' || docTalkSection=='you_may_like'  || docTalkSection=='related_videos'  || docTalkSection=='episode' || docTalkSection=='doctalks_series'   ">

      <div [ngClass]="{'col-12': listLength>1, 'col-md-6': listLength==1}">
        <div class="overflow-hidden position-relative" [ngClass]="callingfrom ===screen.BOOK_MARK || callingfrom === screen.GRAND_ROUND ? '': ''">
          <img [dataTestId]="docCardObj.doctalks_id + '-' + docCardObj?.media?.media_id" [dataTestIdName]="dataTestId.DOC_TALKS_CARD_BANNER" *ngIf="docCardObj?.total_episode!='0'" src="{{(docCardObj?.banner) | fitInImg :igs.imageGroup.fitin_500x500}}" class="doctalk-banner post-pic"
          [ngClass]="{'rounded-0': callingfrom ===screen.BOOK_MARK || callingfrom === screen.GRAND_ROUND}"
            onerror="this.src='assets/themes/icons/video-placeholder.svg'" />

          <img [dataTestId]="docCardObj.doctalks_id + '-' + docCardObj?.media?.media_id" [dataTestIdName]="dataTestId.DOC_TALKS_CARD_BANNER" *ngIf="docCardObj?.total_episode=='0'" src="{{(docCardObj?.media[0]?.media_thumbnail) | fitInImg :igs.imageGroup.fitin_500x500}}" class="doctalk-banner post-pic"
            [ngClass]="{'rounded-0': callingfrom ===screen.BOOK_MARK || callingfrom === screen.GRAND_ROUND}"
            onerror="this.src='assets/themes/icons/video-placeholder.svg'" />
          <!-- details page while playing -->
          <span *ngIf="playTime" class="position-absolute timer-chip-position chip small outline">
            <span class="color-grey-700">{{playTime}}</span>
          </span>
          <!-- {{docCardObj.media | json}} -->
          <img [dataTestId]="docCardObj.doctalks_id + '-' + docCardObj?.media?.media_id" [dataTestIdName]="dataTestId.DOC_TALKS_CARD_BANNER" *ngIf="docCardObj?.media?.media_type==video && docCardObj?.total_episode=='0'"
            class="position-absolute toast-center-center doctalk-play-icon" src="assets/themes/icons/Play.svg" />

          <div class="position-absolute doctalk-overlay-bg w-100 h-100 text-white cursor-pointer doctalk-overlay-hover">
            <div class="position-absolute doctalk-overlay-bg-text w-75 text-center">
              <!-- <p>Playing</p> -->
            </div>
          </div>
          <span *ngIf="docCardObj?.total_episode!='0'"
            class="position-absolute chip small filled error doctalk-episode-icon">{{docCardObj?.total_episode}} {{mls.languageText.doctalk_card.key10}}<span
              *ngIf="mls?.is_lskey_display==1">(doctalk_card.key10)</span></span>
          <!-- percentage video playing -->
          <div class="position-absolute bg-danger video-paused-doctalk" [ngStyle]="{'width': width}"></div>
        </div>
      </div>
      <div class="doctalk-card-text-content cursor-pointer "
        [ngClass]="[callingfrom ===screen.BOOK_MARK || callingfrom === screen.GRAND_ROUND ? 'px-3 pt-3': 'px-4 py-3', listLength > 1 ? 'col-12': 'col-6']">
        <div class="row">
          <div class="col-12 pr-0 doctalk-card-text-max-width">
            <!-- heading -->
            <p [dataTestId]="docCardObj.doctalks_id" [dataTestIdName]="dataTestId.DOC_TALKS_CARD_TITLE" *ngIf="callingfrom!='viewall'" class="secondary-paragraph" style="min-height: 42px">
                {{docCardObj?.title | slice:0:40 }}
                <span *ngIf="docCardObj?.title.length>40">...</span>
                <!-- {{docCardObj?.title | limitTo: 10}} -->
            </p>
            <p [dataTestId]="docCardObj.doctalks_id" [dataTestIdName]="dataTestId.DOC_TALKS_CARD_TITLE" *ngIf="callingfrom=='viewall'" class="secondary-paragraph" style="min-height: 42px">
                {{docCardObj?.title | slice:0:80 }}
                <span *ngIf="docCardObj?.title.length>80">...</span>
                <!-- {{docCardObj?.title | limitTo: 10}} -->
            </p>
          </div>
          <div class="col-2 p-0 text-right dropdown-max-width">
            <!-- dropdown -->
            <app-ngb-drop-down [dataTestId]="docCardObj.doctalks_id" [dataTestIdName]="dataTestId.DOC_TALKS_CARD_DOTS_MENU" [ngbDDL]="ngbDDL" [callingfrom]="callingfrom" (click)="fcs.stopEventPropagation()"
              (resetNgbDDLRecord)="resetNgbDDLRecord($event)"></app-ngb-drop-down>
          </div>
        </div>
        <p class=" mt-1 mb-1 doctalk-text-truncate primary-small">
          <!-- {{docCardObj?.speciality.length}} -->
          <span class="mr-2 color-grey-500"
            (click)="getSpecialty(speciality);"
            *ngFor="let speciality of docCardObj?.speciality | slice:0:1">
            <span [dataTestId]="docCardObj.doctalks_id" [dataTestIdName]="dataTestId.DOC_TALKS_CARD_SPECIALITY">#{{speciality?.speciality_name}}</span>
          </span>
          <span class="primary-small" *ngIf="docCardObj?.speciality?.length>1">
            <span class="color-grey-500 font-weight-bold">+{{docCardObj?.speciality?.length-1}}
            {{mls.languageText.doctalk_card.key11}}<span
              *ngIf="mls?.is_lskey_display==1">(doctalk_card.key11)</span></span></span>
        </p>
        <p [dataTestId]="docCardObj.doctalks_id" [dataTestIdName]="dataTestId.DOC_TALKS_CARD_VIEWS" class="" [ngClass]="{'secondary-paragraph':callingfrom === screen.GRAND_ROUND,'primary-small':callingfrom !== screen.GRAND_ROUND}">
          <span *ngIf="(docCardObj?.in_series == 1 && docTalkSection!='doctalks_series')"
            class="mr-4 position-relative">E{{docCardObj?.episode_index}}</span>
            <span *ngIf="(docCardObj?.in_series == 1 && docTalkSection!='doctalks_series')" class="dot-creating"></span>
          <span [ngClass]="{'color-grey-500': callingfrom === screen.GRAND_ROUND}" class="position-relative"><span *ngIf="docCardObj?.views > 0">
            {{docCardObj?.views}} {{ mls.languageText.doctalk_card.key1 }}
          </span><span *ngIf="(mls?.is_lskey_display==1)">(doctalk_card.key1)</span></span>
        </p>
        <!-- like bookmark and share -->
        <div class="button mt-2" [ngClass]="{'d-none': listLength>1, '': listLength==1}">
          <div class="row ">
            <div class="col-4 text-center pt-2 pb-2">
              <span class="cursor-pointer color-grey-700 doctalk-text-truncate" (click)="fcs.stopEventPropagation(); productLike()">
                <!-- loader  -->
                <img *ngIf="feed_like_loader==true" src="assets/themes/images/primary-loader.gif" alt="loader" width="20px">

                <!-- like -->
                <img loading="lazy" [src]="(docCardObj?.is_like != 1 && feed_like_loader==false)?'assets/themes/icons/like-white.svg':'assets/themes/icons/like-black.svg'" alt="like">
                <br />
                <span class="color-grey-500"  *ngIf="docCardObj?.like > 0">{{docCardObj?.like}} </span>
                <span *ngIf="docCardObj?.is_like!=1">{{mls.languageText.doctalk_card.key2}}<span
                    *ngIf="mls?.is_lskey_display==1">(doctalk_card.key2)</span></span>
                <span *ngIf="docCardObj?.is_like==1">{{mls.languageText.doctalk_card.key8}}<span
                    *ngIf="mls?.is_lskey_display==1">(doctalk_card.key8)</span></span>
              </span>
            </div>
            <div *ngIf="this.mls.featureOnOffList.featureList.bookmark.value || !mls.userLoginFlow" class="col-4 text-center pt-2 pb-2">
              <span class="cursor-pointer color-grey-700 doctalk-text-truncate"
                (click)="fcs.stopEventPropagation(); productBookmark()">
                <!-- loader  -->
                <img *ngIf="feed_bookmark_loader==true" src="assets/themes/images/primary-loader.gif" alt="loader" width="20px">

                <!-- bookmarked -->
                <img loading="lazy" [src]="(docCardObj?.is_bookmarks!=1 && feed_bookmark_loader==false)?'assets/themes/icons/bookmark-white.svg':'assets/themes/icons/bookmark-black.svg'" alt="bookmark">
                <br />
                <span class="color-grey-500" *ngIf="docCardObj?.is_bookmarks!=1">{{mls.languageText.doctalk_card.key3}}<span
                    *ngIf="mls?.is_lskey_display==1">(doctalk_card.key3)</span></span>
                <span *ngIf="docCardObj?.is_bookmarks==1">{{mls.languageText.doctalk_card.key7}}<span
                    *ngIf="mls?.is_lskey_display==1">(doctalk_card.key7)</span></span>
              </span>
            </div>
            <div *ngIf="this.mls.featureOnOffList.featureList.share.value || !mls.userLoginFlow" class="col-4 text-center pt-2 pb-2">
              <span class="cursor-pointer color-grey-700 doctalk-text-truncate"
                (click)="fcs.stopEventPropagation(); productShare( docCardObj.share,docCardObj.product_type,docCardObj.doctalks_id)">
                <img src="assets/themes/icons/share.svg" alt="">
                <br /> {{mls.languageText.doctalk_card.key4}}<span
                  *ngIf="mls?.is_lskey_display==1">(doctalk_card.key4)</span></span>
            </div>
          </div>
        </div>

        <!-- grandround -->

        <div class="mt-2" *ngIf="callingfrom === this.mls.googleEventText.grandround.category"></div>
        <div class="separator-line margin-16px" *ngIf="callingfrom ===screen.BOOK_MARK || callingfrom === screen.GRAND_ROUND"></div>
        <div class="pt-2 pb-2 secondary-paragraph" *ngIf="callingfrom === this.mls.googleEventText.grandround.category">
          <span class="new-modal-like-comment " *ngIf="docCardObj?.like==0"><span class="color-grey-500">{{mls.languageText.doctalk_card.key6}}<span
              *ngIf="mls?.is_lskey_display==1">(doctalk_card.key6)</span></span></span>

          <span class="color-grey-500" *ngIf="docCardObj?.like!=0"
            (click)="fcs.stopEventPropagation(); getProductLikeList();">
            <span class="color-grey-500">{{docCardObj?.like}}</span>
            {{docCardObj?.like>1 ? ' '+mls.languageText.doctalk_card.key5 :  ' '+mls.languageText.doctalk_card.key2}}</span>
          <span *ngIf="mls?.is_lskey_display==1">(doctalk_card.key2)(doctalk_card.key4)</span>
        </div>
        <div class="separator-line margin-16px" *ngIf="callingfrom ===screen.BOOK_MARK || callingfrom === screen.GRAND_ROUND"></div>
        <div class="button"  *ngIf="callingfrom ===screen.BOOK_MARK || callingfrom === screen.GRAND_ROUND">
          <div class="row ">
            <div [class]="(this.mls.featureOnOffList.featureList.share.value 
            || this.mls.featureOnOffList.featureList.bookmark.value 
            || this.mls.featureOnOffList.featureList.repost.value ) || !mls.userLoginFlow ?'like col-3 text-center pt-2 pb-2':'like col-12 text-center pt-2 pb-2'">

              <span class="cursor-pointer color-grey-500 doctalk-text-truncate alignment"
                (click)="fcs.stopEventPropagation(); productLike()">
                <!-- loader  -->
                <img *ngIf="feed_like_loader==true" src="assets/themes/images/primary-loader.gif" alt="loader" width="20px">

                <!-- like -->
                <img src="assets/themes/icons/like-white.svg"
                    alt="like icon"
                    *ngIf="docCardObj?.is_like != 1 && feed_like_loader==false"
                    width="19px" height="19px" class="mr-md-2 bottom-margin"/>
                <img src="assets/themes/icons/like-black.svg"
                    alt="liked icon"
                    *ngIf="docCardObj?.is_like == 1 && feed_like_loader==false"
                    width="19px" height="19px" class="mr-md-2 bottom-margin"/>
                <span class="color-grey-500" *ngIf="docCardObj?.is_like!=1">{{mls.languageText.doctalk_card.key2}}<span
                    *ngIf="mls?.is_lskey_display==1">(doctalk_card.key2)</span></span>
                <span *ngIf="docCardObj?.is_like==1">{{mls.languageText.doctalk_card.key8}}<span
                    *ngIf="mls?.is_lskey_display==1">(doctalk_card.key8)</span></span>
              </span>
            </div>
            <div *ngIf="this.mls.featureOnOffList.featureList.bookmark.value || !mls.userLoginFlow" class="col-3 text-center pt-2 pb-2 px-0">
              <span class="cursor-pointe color-grey-500 doctalk-text-truncate alignment"
                (click)="fcs.stopEventPropagation(); productBookmark()">
                <!-- loader  -->
                <img *ngIf="feed_bookmark_loader==true" src="assets/themes/images/primary-loader.gif" alt="loader" width="20px">

                <!-- bookmarked -->
                <img src="assets/themes/icons/bookmark-white.svg"
                  alt="bookmark icon"
                  *ngIf="docCardObj?.is_bookmarks!=1 && feed_bookmark_loader==false"
                  width="19px" height="19px"
                  class="mr-md-2 bottom-margin"/>

                <img src="assets/themes/icons/bookmark-black.svg"
                  alt="bookmarked icon"
                  *ngIf="docCardObj?.is_bookmarks==1 && feed_bookmark_loader==false"
                  width="19px" height="19px"
                  class="mr-md-2 bottom-margin"/>
                <span class="color-grey-500" *ngIf="docCardObj?.is_bookmarks!=1">{{mls.languageText.doctalk_card.key3}}<span
                    *ngIf="mls?.is_lskey_display==1">(doctalk_card.key3)</span></span>
                <span *ngIf="docCardObj?.is_bookmarks==1">{{mls.languageText.doctalk_card.key7}}<span
                    *ngIf="mls?.is_lskey_display==1">(doctalk_card.key7)</span></span>
              </span>
            </div>
            <div *ngIf="this.mls.featureOnOffList.featureList.repost.value || !mls.userLoginFlow"  class="col-3 text-center pt-2 pb-2 px-0">

            <p *ngIf="docCardObj?.product_type === productTypeConstant.DOCTALKS ">
              <app-repost-popover *ngIf="showRepostPopOver"
                [isInfoModalShown]="true"
                (emitStartRequest)="closeRepostTooltip()"
                (emitHideModal)="closeRepostTooltip()"
                [screenName]="screenName">
              </app-repost-popover>
              <span  (click)="$event.stopPropagation();generateMeta()"class="cursor-pointer button">
                <img width="22px" class="mr-2" src="assets/themes/icons/repost.svg" alt="icon-repost">
                <span class="color-grey-700">{{mls.languageText.webinar_card.key12}}</span>
                <app-repost-type-list-meta *ngIf="isMetaGenerated"
                   [productId]="docCardObj?.product_type_id"
                   (closeToolTip)="closeMeta($event)"
                   [callingFrom]="'DOCTALK_REPOST'"
                   (emitRepostType)="repostDoctalkType($event)">
                </app-repost-type-list-meta>
              </span>
            </p>
          </div>
            <div *ngIf="this.mls.featureOnOffList.featureList.share.value || !mls.userLoginFlow" class="col-3 text-center pt-2 pb-2">
              <span class="cursor-pointer color-grey-500 doctalk-text-truncate alignment"
                (click)="fcs.stopEventPropagation(); productShare( docCardObj.share,docCardObj.product_type,docCardObj.doctalks_id)">
                <img src="assets/themes/icons/share.svg" alt="share"
                class="mr-md-2 bottom-margin" />
                {{mls.languageText.doctalk_card.key4}}<span
                  *ngIf="mls?.is_lskey_display==1">(doctalk_card.key4)</span></span>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>

    <!-- speakers card -->
    <div  [id]="'Doctalks_Top_Speakers-'+docCardObj?.name" class="clearfix px-3 py-2 rounded cursor-pointer d-flex align-items-center" *ngIf="docTalkSection=='top_speakers'"
      (click)="fcs.stopEventPropagation(); navigateToSpeakerdetail(docCardObj?.id, docCardObj?.custom_id)">
      <div class="float-left mr-2 user-56">
        <app-user-pofile-pic [profile_pic_image]="doctalk_user_image"></app-user-pofile-pic>
        </div>
      <div class="float-left speaker-name-max-width">
        <div class="d-table w-100 doctalk-height-layout">
          <div class="d-table-cell align-middle">
            <div class="elips-content position-relative">
              <p class="paragraph-bold">{{docCardObj?.name}}</p>
              <p class="secondary-paragraph">
                <span [id]="'top_speakers-'+docCardObj?.speciality_name" class="mr-4 position-relative color-grey-500">{{docCardObj?.speciality_name}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- speciality card -->
    <div class="position-relative docktalk-speciality-card overflow-hidden" *ngIf="docTalkSection=='speciality'"
      (click)="fcs.stopEventPropagation(); navigatetospeciality(docCardObj.speciality_id)">

      <div class="position-absolute w-100 h-100 text-white cursor-pointer">
        <div class="position-absolute doctalk-overlay-bg-text w-100 text-center logo-wrapper">
          <img width="32px" height="32px" src="{{(docCardObj?.logo) | fitInImg :igs.imageGroup.fitin_500x500}}" onerror="this.src='assets/themes/icons/no-image-placeholder.svg'"
        class="img centered-logo" />
          <p class="paragraph-bold py-2"> 
              <span id = "{{docCardObj?.speciality_name}}-{{docCardObj?.speciality_id}}" class="">{{docCardObj?.speciality_name}}</span>
          </p>
          <p class="secondary-paragraph">
            <span id="{{docCardObj?.speciality_name}}-{{docCardObj?.speciality_id}}-{{docCardObj?.videoCount}}" class="">{{docCardObj?.videoCount}} {{mls.languageText.doctalk_card.key9}}</span>
              <span
              *ngIf="mls?.is_lskey_display==1">(doctalk_card.key9)</span>
          </p>
        </div>
      </div>
    </div>
  </div>
  </div>


  <app-product-subscribe [showSubscribeModal]=showSubscribeModal [channelData]="subscribe_obj"
    (resetSubscribeModal)="resetSubscribeModal()"></app-product-subscribe>
  <app-product-like [callingfrom]="callingfrom" *ngIf="showLikeListModal" (resetLikeModalList)=resetLikeModalList($event)
    (resetLike)=resetLike($event) [likeObj]=likeObj>
  </app-product-like>

<div *ngIf="callingfrom !== screen.BOOK_MARK && callingfrom !== createRepostScreen && callingfrom !== createUserStoryScreen" class="doctalks-card-text-content ">
<div class="separator-line margin-16px" *ngIf="callingfrom === screen.GRAND_ROUND"></div>

<ng-container>
  <div class="position-relative hover-showing doctalk-card" >
    <div class="position-absolute w-100 h-100 masking-card"
    *ngIf="docCardObj?.channel?.content_visibility?.display==0 || docCardObj?.channel?.content_visibility?.display==2">
    <app-product-masking-card [content_visibility]=""></app-product-masking-card>
    </div>
  <div *ngIf="docCardObj?.comment_flag!== numbers.ZERO && callingfrom !== this.screen.DOCTALKS_DETAIL"
      [ngClass]="{'separator-line':this.docCardObj?.total_comments>0}">
      <app-product-comment
          [callingFrom]="callingfrom"
          (emitComment)="emitComment($event)"
          [comment_box_obj]="comment_box_obj"
          (shareCommentCountToParent)=shareCommentCountToParent($event)
          (resetCmtList)="resetCmtList($event)"
          *ngIf="docCardObj?.comment_flag === numbers.ONE"
          [commentObj]="commentObj"
          [showCommentBox]="numbers.ZERO"
          [screen_name]="screen_name"
          [is_activity]="is_activity"
          [list_type]="commentListType.TOP"
          (deleteTotalReplyComment)="deleteTotalReplyComment($event)">
      </app-product-comment>
  </div>
  <div class="pt-3 px-3 separator-line margin-16px" *ngIf="callingfrom === screen.GRAND_ROUND  && docCardObj?.comment_flag!== numbers.ZERO">
      <app-product-comment-box
          [callingFrom]="callingfrom"
          [comment_box_obj]="comment_box_obj"
          (resetComment)="resetComment($event)"
          [emitUserComment]="emitUserComment">
      </app-product-comment-box>
  </div>
</div>
</ng-container>
</div>
